import { LogAnalyticsEvent } from '../../../utils/firebase/firebase';
import { ANALYTICS_KEYS } from '../../../constants/AnalyticKeys';

const useUserMenuHandlers = ({
  setAnchorElUser,
  ACM,
  typeOfUser,
  user,
  logout,
  setSelectedMenuKey,
  updateSelectedMenu,
  navigate,
}) => {
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const settingClickHandler = (setting) => {
    handleCloseUserMenu();
    if (setting.key === 'profile') {
      navigate('/settings');
      updateSelectedMenu('Settings');
    }
    if (setting.key === 'dashboard') {
      ACM[typeOfUser]?.isAdmin ? navigate('/admin') : navigate('/');
      updateSelectedMenu('Home');
    }
    if (setting.key === 'logout') {
      setSelectedMenuKey('Home');

      const logoutKey =
        ACM[typeOfUser]?.isDoctor
          ? ANALYTICS_KEYS.USERS.DOCTORLOGOUT
          : ANALYTICS_KEYS.USERS.PATIENTLOGOUT;

      const userType = typeOfUser ? typeOfUser.toLowerCase() : 'unknown';

      LogAnalyticsEvent(logoutKey, {
        userUid: user.uid,
        message: `${userType} successfully logged out`,
      });
      logout();
      navigate('/main');
    }
  };

  return {
    handleOpenUserMenu,
    handleCloseUserMenu,
    settingClickHandler,
  };
};

export default useUserMenuHandlers; 